export const API_URL = process.env.REACT_APP_API_URL;
export const RECAPTCHA_KEY: string = process.env.REACT_APP_RECAPTCHA_KEY!;